import type { AcademyApi } from '@mathflat/domain/@entities/Academy/api'
import type { DefaultResponse } from '@mathflat/shared/@types/mathflatApi'

import maxios from '../utils/maxios'

export const academyApi = (() => {
  return {
    getAcademies: async () => {
      const { data } = await maxios.get<DefaultResponse<AcademyApi.Response.Academy>>('/academies')
      return data
    },
  }
})()
